import React from 'react';
import { motion } from 'framer-motion';
import { FaCoffee, FaWineGlass, FaUtensils, FaGamepad, FaMapMarkerAlt, FaStar, FaArrowRight, FaLeaf, FaBowlingBall, FaMusic } from 'react-icons/fa';

const PartnerVenuesSection = () => {
  const venues = [
    {
      id: 1,
      name: "Naked Coffee",
      type: "Coffee House",
      description: "You know what makes the heart beat faster? Caffeine. Help attraction along with 10% off food & drinks with our friends, Naked Coffee",
      icon: <FaCoffee className="text-2xl" />,
      rating: 4.8,
      image: "coffee",
      color: "from-amber-600 to-yellow-500",
      location: "Bournemouth"
    },
    {
      id: 2,
      name: "Rock Reef",
      type: "Activity Centre",
      description: "10% OFF PIER ZIP! For thrill-seeking daters! Take in the views of the sparkling sea and stunning shoreline as you fly through the air, like a real pair of Lovebirds.",
      icon: <FaGamepad className="text-2xl" />,
      rating: 4.6,
      image: "activity",
      color: "from-green-400 to-purple-500",
      location: "Bournemouth"
    },
    {
      id: 3,
      name: "My Shake",
      type: "Milkshake Bar",
      description: "Tickle your taste buds on a date at My Shake with 15% OFF!. Sip on creamy milkshakes and savour delicious bites. The perfect recipe for a sweet rendezvous!",
      icon: <FaCoffee className="text-2xl" />,
      rating: 4.9,
      image: "milkshake",
      color: "from-pink-400 to-blue-400",
      location: "Bournemouth"
    },
    {
      id: 4,
      name: "Turtle Bay",
      type: "Caribbean Lounge",
      description: "Download the Turtle Bay App, enter our code and claim £5 off when visiting the Bournemouth restaurant.",
      icon: <FaWineGlass className="text-2xl" />,
      rating: 4.5,
      image: "caribbean",
      color: "from-yellow-400 to-blue-500",
      location: "Bournemouth"
    },
    {
      id: 5,
      name: "Flirt Cafe & Bar",
      type: "Cafe & Bar",
      description: "Come to Flirt Cafe & Bar, where the coffee is hot, the cocktails are cold, and the flirting is encouraged! 10% OFF *Student ID req’d",
      icon: <FaUtensils className="text-2xl" />,
      rating: 4.7,
      image: "cafe-bar",
      color: "from-pink-500 to-purple-500",
      location: "Bournemouth"
    },
    {
      id: 6,
      name: "Mr Mulligans",
      type: "Mini Golf",
      description: "Get 10% off Mr Mulligans’ date night event. 2 Games of Golf, 2 drinks + nachos to share… *Bournemouth outlet only.",
      icon: <FaGamepad className="text-2xl" />,
      rating: 4.4,
      image: "mini-golf",
      color: "from-gray-600 to-blue-500",
      location: "Bournemouth"
    },
    {
      id: 7,
      name: "Forever Green Florist",
      type: "Florist",
      description: "15% OFF! Leave a bloomin’ good impression. From romantic roses to tremendous tulips, tell your date, ‘I like you a bunch’ with a Forever Green Florist bouquet",
      icon: <FaLeaf className="text-2xl" />,
      rating: 4.8,
      image: "florist",
      color: "from-green-500 to-yellow-400",
      location: "Bournemouth"
    },
    {
      id: 8,
      name: "Bowl Central",
      type: "Bowling & Prizes",
      description: "With slick alleys and polished balls of all sizes, meet your match and who knows, maybe it won’t just be the pins getting bowled over… 2 X GAMES £10 PP OR 1 X GAME + DRINK £10 PP",
      icon: <FaBowlingBall className="text-2xl" />,
      rating: 4.6,
      image: "bowling",
      color: "from-blue-600 to-red-500",
      location: "Bournemouth"
    },
    {
      id: 9,
      name: "Boom Battle Bar",
      type: "Battle Bar",
      description: "Fight for love & glory with epic games & drinks at Boom Battle Bar Bournemouth. Challenge your date to a duel of wit & charm. May the best flirt win! 15% OFF ACTIVITES & DRINKS",
      icon: <FaMusic className="text-2xl" />,
      rating: 4.5,
      image: "battle-bar",
      color: "from-purple-600 to-pink-500",
      location: "Bournemouth"
    }
  ];

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        delayChildren: 0.1,
        staggerChildren: 0.05
      }
    }
  };

  const itemVariants = {
    hidden: { y: 50, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: {
        duration: 0.8,
        ease: "easeOut"
      }
    }
  };

  return (
    <section className="py-20 relative w-full">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-7xl">
        <motion.div
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.3 }}
        >
          {/* Section Header */}
          <motion.div variants={itemVariants} className="text-center mb-16">
            <motion.div
              className="inline-flex items-center gap-2 mb-4"
              whileHover={{ scale: 1.05 }}
            >
              <FaMapMarkerAlt className="text-romantic-pink text-2xl" />
              <span className="text-romantic-pink font-semibold text-lg">Partner Venues</span>
            </motion.div>
            <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
              Amazing places to
              <span className="block gradient-text">Meet & Connect</span>
            </h2>
            <p className="text-xl text-gray-300 max-w-3xl mx-auto">
            We’ve partnered with Bournemouth’s best venues to give you perfect date spots, complete with discounts and deals.
            </p>
          </motion.div>

          {/* Venues Grid */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6 mb-12">
            {venues.map((venue, index) => (
              <motion.div
                key={venue.id}
                variants={itemVariants}
                className="group relative"
                whileHover={{ y: -10, scale: 1.02 }}
                transition={{ type: "spring", stiffness: 300 }}
              >
                <div className="glass rounded-2xl p-6 relative overflow-hidden h-full">
                  {/* Background Gradient */}
                  <div className={`absolute inset-0 bg-gradient-to-br ${venue.color} opacity-10 group-hover:opacity-20 transition-opacity duration-300`} />
                  
                  {/* Content */}
                  <div className="relative z-10">
                    {/* Icon & Rating */}
                    <div className="flex items-center justify-between mb-4">
                      <motion.div
                        className={`w-12 h-12 rounded-full bg-gradient-to-br ${venue.color} flex items-center justify-center text-white`}
                        whileHover={{ rotate: 360 }}
                        transition={{ duration: 0.6 }}
                      >
                        {venue.icon}
                      </motion.div>
                      <div className="flex items-center gap-1">
                        <FaStar className="text-yellow-400 text-sm" />
                        <span className="text-white font-semibold text-sm">{venue.rating}</span>
                      </div>
                    </div>

                    {/* Venue Info */}
                    <h3 className="text-xl font-bold text-white mb-2">{venue.name}</h3>
                    <p className="text-romantic-pink text-sm font-semibold mb-3">{venue.type}</p>
                    <p className="text-gray-300 text-sm leading-relaxed mb-4">
                      {venue.description}
                    </p>

                    {/* Location */}
                    <div className="flex items-center gap-2 mb-4">
                      <FaMapMarkerAlt className="text-romantic-pink text-sm" />
                      <span className="text-gray-400 text-sm">{venue.location}</span>
                    </div>

                    {/* Read More Button */}
                    {/* <motion.button
                      className="flex items-center gap-2 text-romantic-pink font-semibold text-sm group-hover:gap-3 transition-all duration-300"
                      whileHover={{ x: 5 }}
                    >
                      Read more
                      <FaArrowRight className="text-xs" />
                    </motion.button> */}
                  </div>

                  {/* Hover Effect */}
                  <motion.div
                    className="absolute inset-0 bg-gradient-to-br from-white to-transparent opacity-0 group-hover:opacity-5 transition-opacity duration-300"
                    initial={false}
                  />
                </div>
              </motion.div>
            ))}
          </div>

          {/* Call to Action */}
          {/* <motion.div
            variants={itemVariants}
            className="text-center"
          >
            <motion.div
              className="inline-flex items-center gap-4 glass rounded-2xl px-8 py-6"
              whileHover={{ scale: 1.05 }}
              transition={{ type: "spring", stiffness: 300 }}
            >
              <div className="text-left">
                <h3 className="text-white font-bold text-lg mb-2">
                  Want to become a partner venue?
                </h3>
                <p className="text-gray-300 text-sm">
                  Join our network of amazing venues in Bournemouth
                </p>
              </div>
              <motion.button
                className="bg-gradient-to-r from-romantic-purple to-romantic-pink text-white px-6 py-3 rounded-full font-semibold flex items-center gap-2 whitespace-nowrap"
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
              >
                Get in Touch
                <FaArrowRight />
              </motion.button>
            </motion.div>
          </motion.div> */}

          {/* Floating Elements */}
          <motion.div
            className="absolute top-1/4 left-4 w-4 h-4 bg-romantic-pink rounded-full opacity-60"
            animate={{
              y: [0, -20, 0],
              x: [0, 10, 0],
            }}
            transition={{ duration: 4, repeat: Infinity }}
          />
          
          <motion.div
            className="absolute bottom-1/4 right-8 w-6 h-6 bg-romantic-blue rounded-full opacity-40"
            animate={{
              y: [0, 15, 0],
              x: [0, -15, 0],
            }}
            transition={{ duration: 5, repeat: Infinity, delay: 2 }}
          />
        </motion.div>
      </div>
    </section>
  );
};

export default PartnerVenuesSection;
